import { useDisclosure } from "@chakra-ui/react"
import { EntityId } from "@jackfruit/common"
import React, { useState } from "react"
import { CloudProviderType } from "./CloudProviderTypes"
import CloudBrowserModal from "./common/CloudBrowserModal"
import { CloudProviderContext as CloudProviderInnerContext } from "./hooks/useCloudProviderContext"

interface Props {
  children: React.ReactElement
}

const CloudProviderContext: React.FC<Props> = ({ children }) => {
  const [currentCloudProvider, setCurrentCloudProvider] =
    useState<CloudProviderType>("your-device")

  const [isImportingImages, setIsImportingImages] = useState(false)

  const { isOpen, onOpen, onClose } = useDisclosure({ defaultIsOpen: false })

  const [lineItemId, setLineItemId] = useState<EntityId | null>(null)
  const [imageRegionId, setImageRegionId] = useState<EntityId | null>(null)

  return (
    <CloudProviderInnerContext.Provider
      value={{
        currentCloudProvider,
        setCurrentCloudProvider,
        isImportingImages,
        setIsImportingImages,
        isCloudProviderModalOpen: isOpen,
        closeCloudProviderModal: onClose,
        openCloudProviderModal: onOpen,
        imageRegionId,
        lineItemId,
        setImageRegionId,
        setLineItemId,
      }}
    >
      {children}
      <CloudBrowserModal onClose={onClose} isOpen={isOpen} />
    </CloudProviderInnerContext.Provider>
  )
}

export default CloudProviderContext
